/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useEffect, useState, useRef } from 'react';
import { theme } from '../../config';
import { useSelector } from 'react-redux';
import { IAuthResponse, ILocationWide, ILocationWideResponse, sxfw } from './../../Interfaces';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { DataGrid, GridColDef, GridColTypeDef, GridColumnHeaderParams, GridRenderCellParams, GridRowClassNameParams, GridRowParams, GridValueFormatterParams, getGridNumericOperators } from '@mui/x-data-grid';
import { useNavigate } from 'react-router-dom';
import { Box, Button  } from '@mui/material';
import { ExportCSV } from './Excel';
import { formattedDate, formattedDateTime } from '../../Helpers/TimeMethods';
import LoginForm from '../../Components/LoginForm';
import { ThemeProvider } from '@emotion/react';
import { TheLegend } from '../../Components/TheLegend';
import { GetWideLocationList } from '../../Data/ApiRequests';
import { useAppDispatch } from '../../hooks';
import { signOut } from '../../Store/appSlicer';
import { StickyDataGrid } from '../../Helpers/DataGridConst';


const LocationList = ( ) => {
  const bearerToken:IAuthResponse = useSelector( (state:IAuthResponse) => state)
  const navigate = useNavigate();
  const showAll: boolean = window.location.pathname.endsWith('/f/')
  const dispatch = useAppDispatch()

    const [data, setData] = useState<ILocationWide[]>([]);
    const [isLoaded,  setIsLoaded] = useState(false);
    const [errorLoad, setErrorLoad] = useState('');
    const gridRef = useRef<HTMLDivElement>(null);
    const arrowsRef = useRef<HTMLDivElement>(null);
    const [isSticky, setIsSticky] = useState(true); // State to track if Box should be sticky
    const footerOffset = 110

    useEffect(() => {
        const fetchData = async () => {
          GetWideLocationList(bearerToken)
          .then(response => {
            const jsonData: ILocationWideResponse[] =  response;
            const objects: ILocationWide[] = []
            // eslint-disable-next-line array-callback-return
            jsonData.map( (x:ILocationWideResponse) => {
              objects.push( {
                  id: x.location.id,
                  wnummer: x.location.wnummer,
                  name: x.location.name,
                  capacity: x.location.capacity,
                  locationCategory: x.location.locationCategory,
                  district: x.location.district,
                  residentGroups: x.location.residentGroups,
                  address: x.location.address,
                  phoneNumber: x.location.phoneNumber,
                  contactPerson: x.location.contactPerson,
                  email: x.location.email,
                  //applicationUserId: x.location.applicationUserId,
                  applicationUserId: x.location.userLocationPermissions.map(x=>x.userId),
                  userLocationPermissions: x.location.userLocationPermissions,
                  startOfOccupancy: x.location.startOfOccupancy,
                  endOfOccupancy: x.location.endOfOccupancy,
                  tl: x.location.tl,
                  bl: x.location.bl,
                  businessDivision: x.location.businessDivision,
                  lastUpdate: (x.roomspace?.lastUpdate !== undefined) ? x.roomspace.lastUpdate : new Date(0),
                  numberOfUnoccupiedSeats: (x.roomspace?.numberOfUnoccupiedSeats !== undefined) ? x.roomspace?.numberOfUnoccupiedSeats : 0,
                  numberOfOccupiedUkr: (x.roomspace?.numberOfOccupiedUkr !== undefined) ? x.roomspace?.numberOfOccupiedUkr : 0,
                  numberOfOccupiedOru: (x.roomspace?.numberOfOccupiedOru !== undefined) ? x.roomspace?.numberOfOccupiedOru : 0,
                  numberOfAvailablePlaces: (x.roomspace?.numberOfAvailablePlaces !== undefined) ? x.roomspace?.numberOfAvailablePlaces : 0,
                  numberOfReservedSeats: (x.roomspace?.numberOfReservedSeats !== undefined) ? x.roomspace?.numberOfReservedSeats : 0,
                  whyNotAssignable: (x.roomspace?.whyNotAssignable  !== undefined) ? x.roomspace?.whyNotAssignable  : '',
                  //singleRoomW: (x.roomspace?.singleRoomW !== undefined) ? x.roomspace?.singleRoomW : 0,
                  //singleRoomM: (x.roomspace?.singleRoomM !== undefined) ? x.roomspace?.singleRoomM : 0,
                  singleRoomFMD: (x.roomspace?.singleRoomFMD !== undefined) ? x.roomspace?.singleRoomFMD : 0,
                  feedSlotW: (x.roomspace?.feedSlotW !== undefined) ? x.roomspace?.feedSlotW : 0,
                  feedSlotM: (x.roomspace?.feedSlotM !== undefined) ? x.roomspace?.feedSlotM : 0,
                  roomForTwo: (x.roomspace?.roomForTwo !== undefined) ? x.roomspace?.roomForTwo : 0,
                  roomForThree: (x.roomspace?.roomForThree !== undefined) ? x.roomspace?.roomForThree: 0,
                  roomForFour: (x.roomspace?.roomForFour !== undefined) ? x.roomspace?.roomForFour: 0,
                  roomForFive: (x.roomspace?.roomForFive !== undefined) ? x.roomspace?.roomForFive: 0,
                  roomForSix: (x.roomspace?.roomForSix !== undefined) ? x.roomspace?.roomForSix: 0,
                  roomForSeven: (x.roomspace?.roomForSeven !== undefined) ? x.roomspace?.roomForSeven: 0,
                  roomForEight: (x.roomspace?.roomForEight !== undefined) ? x.roomspace?.roomForEight: 0,
                  roomForNine: (x.roomspace?.roomForNine !== undefined) ? x.roomspace?.roomForNine: 0,
                  roomForTen: (x.roomspace?.roomForTen !== undefined) ? x.roomspace?.roomForTen: 0,
                  totalSeats: 0,
                  seatsQuantityChanged: (x.roomspace?.seatsQuantityChanged !== undefined) ? x.roomspace?.seatsQuantityChanged: 0,

                  text_FeedSlotM: (x.roomspace?.text_FeedSlotM !== undefined) ? x.roomspace?.text_FeedSlotM: '',
                  text_FeedSlotW: (x.roomspace?.text_FeedSlotW !== undefined) ? x.roomspace?.text_FeedSlotW: '',
                  //text_SingleRoomM: (x.roomspace?.text_SingleRoomM !== undefined) ? x.roomspace?.text_SingleRoomM: '',
                  //text_SingleRoomW: (x.roomspace?.text_SingleRoomW !== undefined) ? x.roomspace?.text_SingleRoomW: '',
                  text_SingleRoomFMD: (x.roomspace?.text_SingleRoomFMD !== undefined) ? x.roomspace?.text_SingleRoomFMD: '',
                  text_RoomForTwo: (x.roomspace?.text_RoomForTwo !== undefined) ? x.roomspace?.text_RoomForTwo: '',
                  text_RoomForThree: (x.roomspace?.text_RoomForThree !== undefined) ? x.roomspace?.text_RoomForThree: '',
                  text_RoomForFour: (x.roomspace?.text_RoomForFour !== undefined) ? x.roomspace?.text_RoomForFour: '',
                  text_RoomForFive: (x.roomspace?.text_RoomForFive !== undefined) ? x.roomspace?.text_RoomForFive: '',
                  text_RoomForSix: (x.roomspace?.text_RoomForSix !== undefined) ? x.roomspace?.text_RoomForSix: '',
                  text_RoomForSeven: (x.roomspace?.text_RoomForSeven !== undefined) ? x.roomspace?.text_RoomForSeven: '',
                  text_RoomForEight: (x.roomspace?.text_RoomForEight !== undefined) ? x.roomspace?.text_RoomForEight: '',
                  text_RoomForNine: (x.roomspace?.text_RoomForNine !== undefined) ? x.roomspace?.text_RoomForNine: '',
                  text_RoomForTen: (x.roomspace?.text_RoomForTen !== undefined) ? x.roomspace?.text_RoomForTen: '',
                  notesOnAccommodation: (x.roomspace?.notesOnAccommodation !== undefined) ? x.roomspace?.notesOnAccommodation : '',
                  allRoomsComments:
`${x.roomspace?.text_SingleRoomFMD ?? ''}
${x.roomspace?.text_RoomForTwo ?? ''}
${x.roomspace?.text_RoomForThree ?? ''}
${x.roomspace?.text_RoomForFour ?? ''}
${x.roomspace?.text_RoomForFive ?? ''}
${x.roomspace?.text_RoomForSix ?? ''}
${x.roomspace?.text_RoomForSeven ?? ''}
${x.roomspace?.text_RoomForEight ?? ''}
${x.roomspace?.text_RoomForNine ?? ''}
${x.roomspace?.text_RoomForTen || ''}`

                }
              )
            })

            if(bearerToken.role === 'User')  {
              if(jsonData.length === 1) { navigate(`/locations/${jsonData[0].location.wnummer}`)}
            }
            setData(objects);
            setIsLoaded(true);
            setErrorLoad('');
          }).catch( error => {
            const er: string = error.toString()
            if(er.indexOf('Unexpected') !== -1 || er.indexOf('Unauthorized') !== -1 || er.indexOf('Sie haben keinen Zugang zu') !== -1) {
              setErrorLoad('Sie haben keinen Zugang zu')
              setTimeout(():void => {
                dispatch(signOut());
                navigate('/')

              }, 3000);
            }
            else {
              setErrorLoad('Error fetching data:' + error)
            }
          })
        };

        if(bearerToken.token === '') {
          setErrorLoad('You are not authorised');
         }
         else {
           fetchData();
         }

         const handleScroll = () => {

          const body = document.body;
          const html = document.documentElement;
          const maxHeight = Math.max(
              body.scrollHeight,
              body.offsetHeight,
              html.clientHeight,
              html.scrollHeight,
              html.offsetHeight
          );
          const coords = arrowsRef.current?.getBoundingClientRect();
          const bottom  = (coords !== undefined) ? coords.bottom : 0;
          const distanceFromBottom = maxHeight - window.scrollY - bottom - footerOffset;
          // If the distance from the bottom is more than 200px, make the Box sticky
          setIsSticky(distanceFromBottom >= footerOffset);
        };

        // Add scroll event listener when the component mounts
        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener when the component unmounts
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, [bearerToken.token]);


  const startOfOccupancyColumn: GridColTypeDef = {
    type: 'date',
    headerName: 'Belegungsstart',
    width: 130,
    valueFormatter: (params: GridValueFormatterParams<Date>) => {
      if (params.value == null) {
        return '';
      }
      return formattedDate( params.value)
    }
  };

  const endOfOccupancyColumn: GridColTypeDef = {
    type: 'date',
    headerName: 'Belegungsende',
    width: 130,
    valueFormatter: (params: GridValueFormatterParams<Date>) => {
      if (params.value == null) {
        return '';
      }
      return formattedDate( params.value)
    }
  };

  const lastUpdateColumn: GridColTypeDef = {
    type: 'date',
    headerName: 'Letzte Meldung vom',
    width: 190,

    valueFormatter: (params: GridValueFormatterParams<Date>) => {
      if (params.value == null) {
        return '';
      }
      if (typeof params.value === 'object')  return '- ';
      return formattedDateTime( params.value)

    }
  };

  const numericFilterOperators = [
    ...getGridNumericOperators(),
  ]

  let columns: GridColDef[] = [];
  if(!showAll) {
    columns = columns.concat([
      // { field: 'id', headerName: '#', width: 150, hideSortIcons: true, sortable: false, filterable: false },
      {
        field: 'wnummer', headerName: 'Leitzeichen', width: 90, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'name', headerName: 'Name des Standortes', width: 120, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'locationCategory', headerName: 'Standortkategorie', width: 130, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'residentGroups', headerName: 'Bewohnergruppen', width: 125, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'district', headerName: 'Bezirk', width: 90, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'address', headerName: 'Adresse', width: 150, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'contactPerson', headerName: 'Ansprechperson', width: 150, hideable: true, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'phoneNumber', headerName: 'Telefonnummer', width: 120, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'email', headerName: 'E-Mail', width: 120, hideable: true, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'startOfOccupancy', ...startOfOccupancyColumn, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'endOfOccupancy', ...endOfOccupancyColumn, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'businessDivision', headerName: 'Geschäftsbereich', width: 150, hideable: true, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'tl', headerName: 'TL', width: 150, hideable: true, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      {
        field: 'bl', headerName: 'BL', width: 150, hideable: true, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
          <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
        )
      },
      { field: 'capacity', headerName: 'Soll-Kapazität', width: 120, flex: 0, filterable: true, type: 'number', filterOperators: numericFilterOperators },
      { field: 'lastUpdate', ...lastUpdateColumn, flex: 0 },
    ]);

    }

    if(showAll) {
      columns = columns.concat(
    [
          { field: 'wnummer', headerName: 'Leitzeichen', width: 90, flex: 0 , renderHeader: (params: GridColumnHeaderParams<any>) => (
            <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
          )},
          { field: 'name', headerName: 'Name des Standortes', width: 120, flex: 0 , renderHeader: (params: GridColumnHeaderParams<any>) => (
            <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
          )},
          { field: 'locationCategory', headerName: 'Standortkategorie', width: 130, flex: 0 , renderHeader: (params: GridColumnHeaderParams<any>) => (
            <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
          )},
          { field: 'residentGroups', headerName: 'Bewohnergruppen', width: 125, flex: 0, renderHeader: (params: GridColumnHeaderParams<any>) => (
            <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
          ) },
          { field: 'district', headerName: 'Bezirk', width: 90, flex: 0,
             renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
           },
          { field: 'address', headerName: 'Adresse', width: 150, flex: 0 ,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },
          { field: 'contactPerson', headerName: 'Ansprechperson', width: 150, hideable: true, flex: 0 ,
             renderHeader: (params: GridColumnHeaderParams<any>) => (
            <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
          )},
          { field: 'phoneNumber', headerName: 'Telefonnummer', width: 120, flex: 0,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
            <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
          ) },
          {
            field: 'email', headerName: 'E-Mail', width: 120, hideable: true, flex: 0,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },
          { field: 'tl', headerName: 'TL', width: 150, hideable: true, flex: 0,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
           },
          { field: 'bl', headerName: 'BL', width: 150, hideable: true, flex: 0 ,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },

          {
            field: 'numberOfOccupiedUkr', headerName: 'Anzahl Ist-Belegung Ukrainer', width: 120, flex: 0, sortable: false, filterable: false,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },
          { field: 'numberOfOccupiedOru', headerName: 'Anzahl Ist-Belegung örU', width: 120, flex: 0, sortable: false, filterable: false ,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },
          {
            field: 'numberOfAvailablePlaces', headerName: 'Anzahl belegbare Plätze', width: 140, flex: 0, filterable: true, type: 'number', align: 'left',
            filterOperators: numericFilterOperators,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },
          { field: 'numberOfReservedSeats', headerName: 'Anzahl reservierter Plätze', width: 120, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
           },
           { field: 'numberOfUnoccupiedSeats', headerName: 'Anzahl nicht belegbarer Plätze', width: 120, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
           },
          { field: 'whyNotAssignable', headerName: 'Warum nicht belegbar?', width: 150, flex: 0, sortable: false, filterable: false ,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },
          //{ field: 'singleRoomW', headerName: 'Anzahl Einzelzimmer w', width: 120, flex: 0, sortable: false, filterable: false,  type: 'number', align: 'left'},
          //{ field: 'singleRoomM', headerName: 'Anzahl Einzelzimmer m', width: 120, flex: 0, sortable: false, filterable: false,  type: 'number', align: 'left'},

          {
            field: 'singleRoomFMD', headerName: 'Anzahl Einzelzimmer (w/m/d)', width: 120, flex: 0, sortable: false, filterable: false,
            type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },

          {
            field: 'text_SingleRoomFMD', headerName: 'Belegungshinweise',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },
          {
            field: 'feedSlotW', headerName: 'Anzahl Platz in bereits belegtem Zimmer w', width: 120, flex: 0, sortable: false, type: 'number', align: 'left', filterable: false,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )},

          {
            field: 'text_FeedSlotW', headerName: 'Belegungshinweise',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },

          {
            field: 'feedSlotM', headerName: 'Anzahl Platz in bereits belegtem Zimmer m', width: 120, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )},

          {
            field: 'text_FeedSlotM', headerName: 'Anmerkungen zur Zimmer m',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },

          {
            field: 'roomForTwo', headerName: 'Anzahl 2er Zimmer', width: 100, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )},

          {
            field: 'text_RoomForTwo', headerName: 'Anmerkungen zur 2er',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },
          {
            field: 'roomForThree', headerName: 'Anzahl 3er Zimmer', width: 100, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left' ,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )},

          {
            field: 'text_RoomForThree', headerName: 'Anmerkungen zur 3er',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },
          {
            field: 'roomForFour', headerName: 'Anzahl 4er Zimmer', width: 100, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left' ,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )},

          {
            field: 'text_RoomForFour', headerName: 'Anmerkungen zur 4er',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },

          {
            field: 'roomForFive', headerName: 'Anzahl 5er Zimmer', width: 100, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )},

          {
            field: 'text_RoomForFive', headerName: 'Anmerkungen zur 5er',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },

          {
            field: 'roomForSix', headerName: 'Anzahl 6er Zimmer', width: 100, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },
          {
            field: 'text_RoomForSix', headerName: 'Anmerkungen zur 6er',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },

          {
            field: 'roomForSeven', headerName: 'Anzahl 7er Zimmer', width: 100, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )},
          {
            field: 'text_RoomForSeven', headerName: 'Anmerkungen zur 7er',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },

          {
            field: 'roomForEight', headerName: 'Anzahl 8er Zimmer', width: 100, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )},

          {
            field: 'text_RoomForEight', headerName: 'Anmerkungen zur 8er',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },

          { field: 'roomForNine', headerName: 'Anzahl 9er Zimmer', width: 100, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
           },

          {
            field: 'text_RoomForNine', headerName: 'Anmerkungen zur 9er',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },

          { field: 'roomForTen', headerName: 'Anzahl 10er Zimmer', width: 100, flex: 0, sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
           },
          {
            field: 'text_RoomForTen', headerName: 'Anmerkungen zur 10er',
            minWidth: 140, flex: 0, sortable: false, filterable: false,
            type: 'string', align: 'left', resizable: true,
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            ),
            renderCell: (params: GridRenderCellParams<any>) => (
              <div style={{ whiteSpace: "normal", wordBreak: "break-word" }}>{params.value ?? ''}</div>
            ),
          },
          { field: 'notesOnAccommodation', headerName: 'Anmerkungen zur zu den Plätzen', sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )
          },
          { field: 'allRoomsComments', headerName: 'Anmerkungen zur Unterbringung', sortable: false, filterable: false, type: 'number', align: 'left',
            renderHeader: (params: GridColumnHeaderParams<any>) => (
              <div className='dataGridHeaderCell' >{params.colDef.headerName}</div>
            )}
  ]);
}

/* eslint-disable  @typescript-eslint/no-explicit-any */
const getMyRowClassName = (params: GridRowClassNameParams<any>) => {
  return (params.indexRelativeToCurrentPage % 2 === 0) ? 'stripeOdd' : 'stripeEven'
};


  const getRowClassNameForWide = (params: GridRowClassNameParams<any>) => {
    const lup:Date = new Date(params.row.lastUpdate)
    const toHilite: boolean = lup.setHours(lup.getHours() + 36) < Date.now()
    const seatsChanged: boolean = (params.row.seatsQuantityChanged === 1);
    if (toHilite) return 'highlighted-row';
    if (seatsChanged) return 'highlightedGreen-row';
    return '';
  };

    function selectGridRow(params: GridRowParams<any>): void {
        if(showAll) navigate("/freespace/" + params.row.wnummer)
        if(!showAll)  navigate("/locations/" + params.row.wnummer)
    }

    function selectGridRowHoster(params: GridRowParams<any>): void {
      navigate("/freespace/" + params.row.wnummer)
  }

  const exportToExcel = async() => {
    ExportCSV(data, (showAll) ? 'freiplatz' : 'standort')
  }


  const handleClick = (position: string) => () => {
    if (gridRef.current) {
      const t = gridRef.current.getElementsByClassName('MuiDataGrid-virtualScroller')
      if (t !== null) {
        const currentScrollX = t[0].scrollLeft
        if (position.toLowerCase() === 'left') {
          t[0].scrollTo({ left: currentScrollX - 200 })
        }
        if (position.toLowerCase() === 'right') {
          t[0].scrollTo({ left: currentScrollX + 200 })
        }

      }
    }
  };






    return (
        <div >

        {
          (!bearerToken.isLoggedIn) && <>
          {/* <div className='errorText' style={{ padding: '15px' }}>You are not authorised</div> */}
          <Box sx={sxfw} >
            <LoginForm />
          </Box>
          </>
        }

        {
          (bearerToken.isLoggedIn) &&
            <>
            { !showAll && <h2>Standorte</h2> }
            { showAll && <h2>Freiplatzmeldungen</h2> }
            </>
        }


        {
          (!isLoaded && bearerToken.isLoggedIn) && <div>Loading ...</div>
        }

            {
                (bearerToken.isLoggedIn && bearerToken.role === 'Admin') &&
                <>
                <div className='buttons' style={{display: 'flex', flexDirection: 'row'}}>
                  <Box  sx={sxfw}>
                  <Button onClick={() => { exportToExcel()}} variant='contained' className='excel'>Excel Export</Button></Box>
                  {
                    !showAll  &&
                    <Box  sx={sxfw}>
                    <Button onClick={ () => navigate("/locations/new" )} variant='outlined' color='success'>Neuen Standort hinzufügen</Button></Box>
                  }
                </div>



            {/* <div style={{ width: 'calc(100%-50px)', overflow: 'none' }}> */}
            { errorLoad }

            {
              errorLoad === '' &&
              <ThemeProvider theme={theme}>
              {
                bearerToken.isLoggedIn && <TheLegend />
              }
 {/* display: { xs: 'flex', md: 'none' }, */}
<Box ref={arrowsRef} id='arrowsID'
    sx={{ background: 'rgba(255,255, 255, 0.8)', flexGrow: 1,
    position: 'fixed',
    bottom: isSticky ?  0 : footerOffset,

    left: 0, zIndex: 1002 }}>
{/* <Button onClick={handleClick('top')}>Top</Button> */}
<Button onClick={handleClick('left')}><ArrowCircleLeftIcon /></Button>
<Button onClick={handleClick('right')}><ArrowCircleRightIcon /></Button>
{/* <Button onClick={handleClick('down')}>Down</Button> */}

</Box>


                  <StickyDataGrid
                    ref={gridRef}
                    onRowClick={selectGridRow}
                    showColumnVerticalBorder={true}
                    scrollbarSize={0} style={{ margin: 0 }}
                    showCellVerticalBorder
                    hideFooter={false}
                    pagination={true}
                    pageSizeOptions={[25, 50, 100]}
                    initialState={{
                      pagination: {paginationModel: {pageSize: 50}},
                    }}
                    rows={data}
                    columns={columns}
                    sx={{
                      padding: 0, margin: 0, fontSize: 13,
                      "& .MuiDataGrid-columnHeaderTitle": {
                        whiteSpace: "normal",
                        lineHeight: "normal", fontSize: 12
                      },

                    }}

                    slotProps={{
                      filterPanel: {
                        sx: {
                          "& .MuiDataGrid-filterFormColumnInput": {
                            p: '0px 10px',
                            m: '0px 10px',
                            width: '260px'
                          },

                          '& .MuiDataGrid-filterFormOperatorInput': {
                            width: '160px'
                          }
                        }
                      }
                    }}


                    getRowId={(row: any) => row.wnummer}
                    getRowClassName={ showAll ? getRowClassNameForWide : getMyRowClassName}
                  /></ThemeProvider>
            }

            {/* </div> */}
                </>
            }

        {
          (bearerToken.isLoggedIn && bearerToken.role === 'User') &&
          <>

          {
            data.length === 0 && <b>No data</b>
          }
              <div style={{ width: 'calc(100%-50px)', overflow: 'none' }}>

            <DataGrid
              onRowClick={selectGridRowHoster}
              scrollbarSize={1} style={{margin: 0}}
              showCellVerticalBorder
                  rows={data}
                  columns={columns}
                  sx={{ padding: 0, margin: 0, fontSize: 13,
                    "& .MuiDataGrid-columnHeaderTitle": {
                      whiteSpace: "normal",
                      lineHeight: "normal", fontSize: 12
                    },
                  }}
                  getRowId={(row: any) => row.wnummer}
                  getRowClassName={getMyRowClassName}
            /><br />&nbsp;<br />

            </div>
          </>
        }

{
  bearerToken.isLoggedIn && <TheLegend />
}

        </div>
    );
};

export default LocationList;
